exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-666a6cba] .el-card__body{height:100%}[data-v-666a6cba] .el-icon-arrow-right{display:none}", ""]);

// exports
